import { EConfigurations } from "../enums/configurations";

export function configurationDescription(configuration: EConfigurations) {
  switch (configuration) {
    case EConfigurations.BRAND_PRIORITY:
      return "System picks components based on brand priority list.";
    case EConfigurations.BRAND_PRIORITY_LIST:
      return "Brand Priority List";
    case EConfigurations.SAME_BRAND_ECOSYSTEM:
      return "Avoids mixing too many brands or exotic combinations. System will lean toward more reliable, straightforward setups.";
    case EConfigurations.MINIMIZE_COMPONENT_COUNT:
      return "This keeps the system simpler. (Recommend one larger component instead of multiple small ones) ";
    case EConfigurations.MATCH_VOLTAGE_ACROSS_COMPONENTS:
      return "All selected parts (panels, batteries, inverters, etc.) should use the same voltage";
    case EConfigurations.MINIMIZE_MAINTENANCE_RISK:
      return "If a full set of components from the same brand is available priority will be given to that.";
    case EConfigurations.OPTIMIZE_FOR_COST:
      return "When this is active, the system tries to find the cheapest configuration that matches the requirement.";
    case EConfigurations.PREFER_HIGH_EFFICIENCY_PANELS:
      return "Useful when roof space is tight. Instead of using lots of low-power panels suggest high power ones. ";
    case EConfigurations.RECOMMEND_EXPANDABLE_SYSTEMS:
      return "When this is enabled, the system only suggests setups that can grow later.";
    default:
      return "";
  }
}
